









































import { Vue, Component, Prop } from "vue-property-decorator"
import { getModule } from "vuex-module-decorators"
import { Server } from "@/store/server"

@Component
export default class InviteModal extends Vue {
  @Prop({ default: false }) active!: boolean

  email = ''
  role: "member" | "viewer" = 'member'
  sending = false

  get emailError() {
    if (this.email.length === 0) return ''
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return re.test(this.email) ? '' : '有効なメールアドレスを入力してください。'
  }

  get canSubmit() {
    return this.email.length > 0 && this.emailError === '' && !this.sending
  }

  async submit() {
    this.sending = true
    try {
      await getModule(Server).postMyInvitation({ email: this.email, role: this.role })
      this.email = ''
      this.role = 'member'
      this.$emit('invited')
    } catch (error) {
      this.$buefy.toast.open({ message: '招待の送信に失敗しました。', type: 'is-danger' })
    } finally {
      this.sending = false
    }
  }
}
